import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g>
      <polygon className="euiIcon__fillSecondary" points="20.38 7.001 17 9.619 17 0 15 0 15 9.619 11.63 7.001 10.38 8.514 16 12.878 21.63 8.514"/>
      <path
        d="M21.06,0.164848485 L19.95,1.77454545 L29.2,7.75757576 L16,16.2909091 L2.8,7.75757576 L12.05,1.77454545 L10.95,0.164848485 L0,7.23393939 L0,20.8872727 L16,31.2242424 L32,20.8872727 L32,7.23393939 L21.06,0.164848485 Z M2,9.57090909 L15,17.9781818 L15,28.2569697 L2,19.84 L2,9.57090909 Z M17,28.2472727 L17,17.9781818 L30,9.57090909 L30,19.849697 L17,28.2472727 Z"/>
    </g>
  </svg>
);
